/* Bellani Pets treat finder (owner: Collection agent).
   <bp-treat-finder> filters the rendered product cards client side using data-tags on
   [data-product-card]: need:*, pet:dog-only, size:medium-up.
   Deep links: ?pet=dog|cat&size=small|medium|large&need=training|picky|sensitive|lowcal|chew|cat-favorite
   Plain ES2019, no framework. */
(function () {
  'use strict';

  if (window.customElements && customElements.get('bp-treat-finder')) return;

  var PETS = ['all', 'dog', 'cat'];
  var SIZES = ['any', 'small', 'medium', 'large'];
  var NEEDS = ['all', 'training', 'picky', 'sensitive', 'lowcal', 'chew', 'cat-favorite'];
  var ALIASES = {
    pet: { dogs: 'dog', cats: 'cat', both: 'all', any: 'all' },
    size: { all: 'any', under20: 'small', 'under-20': 'small', '20-50': 'medium', over50: 'large', 'over-50': 'large' },
    need: { cat: 'cat-favorite', cats: 'cat-favorite', 'cat-favorites': 'cat-favorite', chews: 'chew', 'low-calorie': 'lowcal', 'low-cal': 'lowcal', toppers: 'picky', everything: 'all' }
  };
  var ALLOWED = { pet: PETS, size: SIZES, need: NEEDS };

  function normalize(key, raw) {
    if (raw == null) return null;
    var v = String(raw).trim().toLowerCase();
    if (ALIASES[key][v]) v = ALIASES[key][v];
    return ALLOWED[key].indexOf(v) === -1 ? null : v;
  }

  function parseTags(str) {
    return (str || '').split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
  }

  class BpTreatFinder extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.defaultPet = normalize('pet', this.dataset.defaultPet) || 'all';
      this.countOne = this.dataset.countOne || '1 treat';
      this.countMany = this.dataset.countMany || '[count] treats';

      this.pills = Array.prototype.slice.call(this.querySelectorAll('[data-filter]'));
      this.sizeStep = this.querySelector('[data-step="size"]');
      this.needNumber = this.querySelector('[data-need-number]');
      this.countEl = this.querySelector('[data-finder-count]');
      this.emptyEl = this.querySelector('[data-finder-empty]');
      this.sortForm = this.querySelector('[data-finder-sort]');
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-finder-item]')).map(function (li) {
        var card = li.querySelector('[data-product-card]');
        return { el: li, tags: parseTags(card ? card.getAttribute('data-tags') : '') };
      });

      if (this.emptyEl) {
        this.emptyTitle = this.emptyEl.querySelector('[data-empty-title]');
        this.emptyText = this.emptyEl.querySelector('[data-empty-text]');
        this.emptyBtn = this.emptyEl.querySelector('[data-empty-action]');
        this.genericCopy = {
          title: this.emptyTitle ? this.emptyTitle.textContent : '',
          text: this.emptyText ? this.emptyText.textContent : '',
          button: this.emptyBtn ? this.emptyBtn.textContent : ''
        };
        var tpl = this.emptyEl.querySelector('template[data-empty-chews]');
        var frag = tpl ? tpl.content : null;
        this.chewsCopy = {
          title: frag && frag.querySelector('[data-title]') ? frag.querySelector('[data-title]').textContent : 'Chews are for dogs only',
          text: frag && frag.querySelector('[data-text]') ? frag.querySelector('[data-text]').textContent : '',
          button: frag && frag.querySelector('[data-button]') ? frag.querySelector('[data-button]').textContent : 'Show cat favorites'
        };
      }

      this.state = this.readUrl();

      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);

      if (this.sortForm) {
        var select = this.sortForm.querySelector('select[name="sort_by"]');
        if (select) select.addEventListener('change', this.onSort.bind(this));
        this.sortForm.addEventListener('submit', this.onSortSubmit.bind(this));
      }

      this.render(false);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this._ready = false;
    }

    readUrl() {
      var params = new URLSearchParams(window.location.search);
      var pet = normalize('pet', params.get('pet')) || this.defaultPet;
      var size = normalize('size', params.get('size')) || 'any';
      var need = normalize('need', params.get('need')) || 'all';
      if (pet !== 'dog') size = 'any';
      return { pet: pet, size: size, need: need };
    }

    set(patch) {
      var next = Object.assign({}, this.state, patch);
      if (next.pet !== 'dog') next.size = 'any';
      this.state = next;
      this.render(true);
    }

    onClick(event) {
      var pill = event.target.closest('[data-filter]');
      if (pill && this.contains(pill)) {
        var key = pill.getAttribute('data-filter');
        var value = normalize(key, pill.getAttribute('data-value'));
        if (!value) return;
        var patch = {};
        patch[key] = value;
        this.set(patch);
        return;
      }
      var action = event.target.closest('[data-empty-action]');
      if (action && this.contains(action)) {
        if (this.emptyMode === 'chews') {
          this.set({ need: 'cat-favorite' });
        } else {
          this.set({ need: 'all', size: 'any' });
        }
        var first = this.querySelector('[data-filter="need"][aria-pressed="true"]');
        if (first) first.focus();
      }
    }

    filterParams() {
      var p = {};
      if (this.state.pet !== this.defaultPet) p.pet = this.state.pet;
      if (this.state.pet === 'dog' && this.state.size !== 'any') p.size = this.state.size;
      if (this.state.need !== 'all') p.need = this.state.need;
      return p;
    }

    writeUrl() {
      if (!window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      ['pet', 'size', 'need'].forEach(function (k) { url.searchParams.delete(k); });
      var p = this.filterParams();
      Object.keys(p).forEach(function (k) { url.searchParams.set(k, p[k]); });
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    }

    onSort(event) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.delete('page');
      ['pet', 'size', 'need'].forEach(function (k) { url.searchParams.delete(k); });
      var p = this.filterParams();
      Object.keys(p).forEach(function (k) { url.searchParams.set(k, p[k]); });
      window.location.assign(url.pathname + url.search);
    }

    onSortSubmit(event) {
      event.preventDefault();
      var select = this.sortForm.querySelector('select[name="sort_by"]');
      if (select) this.onSort({ target: select });
    }

    matches(tags) {
      var s = this.state;
      if (s.pet === 'cat' && tags.indexOf('pet:dog-only') !== -1) return false;
      if (s.pet === 'dog' && s.size === 'small' && tags.indexOf('size:medium-up') !== -1) return false;
      if (s.need !== 'all' && tags.indexOf('need:' + s.need) === -1) return false;
      return true;
    }

    render(updateUrl) {
      var s = this.state;
      var self = this;

      this.pills.forEach(function (pill) {
        var key = pill.getAttribute('data-filter');
        var on = normalize(key, pill.getAttribute('data-value')) === s[key];
        pill.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      if (this.sizeStep) this.sizeStep.hidden = s.pet !== 'dog';
      if (this.needNumber) this.needNumber.textContent = s.pet === 'dog' ? '3' : '2';

      var count = 0;
      this.items.forEach(function (item) {
        var show = self.matches(item.tags);
        item.el.hidden = !show;
        if (show) count += 1;
      });

      if (this.countEl) {
        this.countEl.textContent = count === 1 ? this.countOne : this.countMany.replace('[count]', String(count));
      }

      if (this.emptyEl) {
        var isEmpty = this.items.length > 0 && count === 0;
        this.emptyEl.hidden = !isEmpty;
        if (isEmpty) {
          this.emptyMode = s.pet === 'cat' && s.need === 'chew' ? 'chews' : 'generic';
          var copy = this.emptyMode === 'chews' ? this.chewsCopy : this.genericCopy;
          if (this.emptyTitle) this.emptyTitle.textContent = copy.title;
          if (this.emptyText) {
            this.emptyText.textContent = copy.text;
            this.emptyText.hidden = !copy.text;
          }
          if (this.emptyBtn) this.emptyBtn.textContent = copy.button;
        }
      }

      if (updateUrl) this.writeUrl();

      this.dispatchEvent(new CustomEvent('bp:finder:change', {
        bubbles: true,
        detail: { pet: s.pet, size: s.size, need: s.need, count: count }
      }));
    }
  }

  if (window.customElements) customElements.define('bp-treat-finder', BpTreatFinder);
})();
